import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

var _paypalRadio$dataset, _paypalOptions$client;

import _regeneratorRuntime from "@babel/runtime/regenerator";
import FormValidation from '../Vendor/formvalidation/es6/core/Core';
import Icon from '../Vendor/formvalidation/es6/plugins/Icon';
import Trigger from '../Vendor/formvalidation/es6/plugins/Trigger';
import AutoFocus from '../Vendor/formvalidation/es6/plugins/AutoFocus';
import SubmitButton from '../Vendor/formvalidation/es6/plugins/SubmitButton';
import Declarative from '../Vendor/formvalidation/es6/plugins/Declarative';
import Bootstrap5 from '../Vendor/formvalidation/es6/plugins/Bootstrap5';
import Excluded from '../Vendor/formvalidation/es6/plugins/Excluded';
import MollieInline from './mollie-inline';
import { loadScript } from "@paypal/paypal-js";

if (window.mollieProfileId) {
  window.mollieInline = new MollieInline(window.mollieProfileId);
}

if ($('#checkout-card-token').length) {
  $('#checkout-card-token').val('');
}

var checkoutForm = document.getElementById('checkout-form');
var checkoutButton = document.getElementById('checkout-button');
var fieldPfx = '--seven_offerpage_checkout-content_checkout_form[order]';
var paypalRadio = document.querySelector('input[data-type="paypal"]');
var paypalOptions = Object.assign({}, (_paypalRadio$dataset = paypalRadio === null || paypalRadio === void 0 ? void 0 : paypalRadio.dataset) !== null && _paypalRadio$dataset !== void 0 ? _paypalRadio$dataset : {});
var usePayPalSDK = Boolean(paypalOptions === null || paypalOptions === void 0 ? void 0 : (_paypalOptions$client = paypalOptions.clientId) === null || _paypalOptions$client === void 0 ? void 0 : _paypalOptions$client.length);

if (checkoutForm) {
  var fv = new FormValidation(checkoutForm, {
    plugins: {
      declarative: new Declarative({
        html5Input: true
      }),
      trigger: new Trigger(),
      autoFocus: new AutoFocus(),
      submitButton: new SubmitButton(),
      bootstrap: new Bootstrap5({
        rowSelector: '.mb-3'
      }),
      icon: new Icon({
        valid: 'fa fa-check',
        invalid: 'fa fa-times',
        validating: 'fa fa-refresh'
      }),
      excluded: new Excluded({
        excluded: function excluded(field) {
          var excludeField = false;
          var selectedPaymentMethod = $("#checkout-form input[name=\"".concat(fieldPfx, "[paymentMethod]\"]:checked")).data('type');

          if (selectedPaymentMethod !== 'afterpay') {
            excludeField = field === "".concat(fieldPfx, "[attributes][birthDay][0]") || field === "".concat(fieldPfx, "[attributes][birthDay][1]") || field === "".concat(fieldPfx, "[attributes][birthDay][2]") || field === 'afterpay-terms';

            if (excludeField === true) {
              return excludeField;
            }
          }

          if (selectedPaymentMethod !== 'checkoutCom') {
            excludeField = field === "".concat(fieldPfx, "[paymentDetails][checkoutCardToken]");

            if (excludeField === true) {
              return excludeField;
            }
          }

          if (selectedPaymentMethod !== 'mollie-creditCard') {
            excludeField = field === "".concat(fieldPfx, "[paymentDetails][cardToken]");

            if (excludeField === true) {
              return excludeField;
            }
          }
        }
      })
    }
  }).on('core.form.valid', function () {
    if (!usePayPalSDK || getSelectedPaymentMethod() !== 'paypal') {
      $('#checkout-loader').fadeIn();
      checkoutForm.submit();
    }
  }).on('core.element.validating', function (element) {
    if (typeof Frames !== 'undefined' && element.field === "".concat(fieldPfx, "[paymentDetails][checkoutCardToken]")) {
      if ($('#checkout-card-token').val() !== '') {
        return;
      }

      Frames.submitCard().then(function (response) {
        $('#checkout-card-token').val(response.token);
        fv.validate();
      }).catch(function () {
        $('#checkout-empty-error').removeClass('d-none');
      });
    }

    if (window.mollieInline !== undefined && element.field === "".concat(fieldPfx, "[paymentDetails][cardToken]")) {
      if ($('#card-token').val() !== '') {
        return;
      }

      window.mollieInline.createCardToken().then(function (token) {
        $('#card-token').val(token);
        fv.validate();
      }, function (error) {});
    }
  });

  if (usePayPalSDK) {
    var paypalErrorBox = document.getElementById('paypal-error');
    loadScript({
      'client-id': paypalOptions.clientId,
      'currency': window.checkoutConfig.currency,
      'locale': window.checkoutConfig.locale,
      'enable-funding': 'paylater',
      'disable-funding': 'card,sepa,giropay,sofort',
      'integration-date': '2023-03-29',
      'components': 'buttons,messages,funding-eligibility'
    }).then( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(paypal) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return paypal.Buttons({
                  style: {
                    layout: 'vertical',
                    color: 'gold',
                    tagline: false,
                    label: 'pay'
                  },
                  createOrder: function () {
                    var _createOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, actions) {
                      var formData, orderData, res, responseData, paypalOrder;
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              paypalErrorBox.classList.add('d-none');
                              formData = new FormData(checkoutForm);
                              orderData = {
                                order: {
                                  customer: {
                                    gender: formData.get("".concat(fieldPfx, "[customer][gender]")),
                                    firstName: formData.get("".concat(fieldPfx, "[customer][firstName]")),
                                    lastName: formData.get("".concat(fieldPfx, "[customer][lastName]")),
                                    street: formData.get("".concat(fieldPfx, "[customer][street]")),
                                    streetNumber: formData.get("".concat(fieldPfx, "[customer][streetNumber]")),
                                    zipCode: formData.get("".concat(fieldPfx, "[customer][zipCode]")),
                                    city: formData.get("".concat(fieldPfx, "[customer][city]")),
                                    email: formData.get("".concat(fieldPfx, "[customer][email]")),
                                    phoneNumber: formData.get("".concat(fieldPfx, "[customer][phoneNumber]")),
                                    country: window.checkoutConfig.country
                                  },
                                  paymentMethod: formData.get("".concat(fieldPfx, "[paymentMethod]")),
                                  product: formData.get("".concat(fieldPfx, "[product]"))
                                },
                                locale: window.checkoutConfig.neosLocale
                              };
                              _context.next = 5;
                              return fetch('/api/checkout/create', {
                                method: 'post',
                                body: JSON.stringify(orderData),
                                headers: {
                                  'content-type': 'application/json'
                                }
                              });

                            case 5:
                              res = _context.sent;
                              _context.next = 8;
                              return res.json();

                            case 8:
                              responseData = _context.sent;

                              if (responseData.success) {
                                _context.next = 11;
                                break;
                              }

                              throw new Error('Order could not be created');

                            case 11:
                              paypalOrder = {
                                payer: {
                                  name: {
                                    given_name: orderData.order.customer.firstName,
                                    surname: orderData.order.customer.lastName
                                  },
                                  email_address: orderData.order.customer.email
                                },
                                application_context: {
                                  brand_name: window.checkoutConfig.paypalExpress.brandName,
                                  shipping_preference: 'SET_PROVIDED_ADDRESS'
                                },
                                purchase_units: [{
                                  invoice_id: responseData.orderId,
                                  description: window.checkoutConfig.paypalExpress.brandName,
                                  amount: {
                                    value: responseData.total / 100,
                                    currency_code: responseData.currency
                                  },
                                  shipping: {
                                    name: {
                                      full_name: orderData.order.customer.firstName + ' ' + orderData.order.customer.lastName
                                    },
                                    address: {
                                      address_line_1: orderData.order.customer.street + ' ' + orderData.order.customer.streetNumber,
                                      admin_area_2: orderData.order.customer.city,
                                      postal_code: orderData.order.customer.zipCode,
                                      country_code: window.checkoutConfig.country
                                    }
                                  }
                                }]
                              };
                              return _context.abrupt("return", actions.order.create(paypalOrder));

                            case 13:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    function createOrder(_x2, _x3) {
                      return _createOrder.apply(this, arguments);
                    }

                    return createOrder;
                  }(),
                  onApprove: function () {
                    var _onApprove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data, actions) {
                      var details;
                      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              _context2.next = 2;
                              return actions.order.capture();

                            case 2:
                              details = _context2.sent;
                              _context2.next = 5;
                              return fetch('/api/checkout/completePayment', {
                                method: 'post',
                                body: JSON.stringify({
                                  completePayment: {
                                    paymentId: details.id,
                                    orderId: details.purchase_units[0].invoice_id,
                                    processorId: paypalRadio.value
                                  },
                                  locale: window.checkoutConfig.neosLocale
                                }),
                                headers: {
                                  'content-type': 'application/json'
                                }
                              });

                            case 5:
                              window.location = window.checkoutConfig.thankYouPage;

                            case 6:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2);
                    }));

                    function onApprove(_x4, _x5) {
                      return _onApprove.apply(this, arguments);
                    }

                    return onApprove;
                  }(),
                  onClick: function () {
                    var _onClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data, actions) {
                      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              _context3.next = 2;
                              return fv.validate();

                            case 2:
                              _context3.t0 = _context3.sent;

                              if (!(_context3.t0 === 'Invalid')) {
                                _context3.next = 7;
                                break;
                              }

                              _context3.t1 = actions.reject();
                              _context3.next = 8;
                              break;

                            case 7:
                              _context3.t1 = actions.resolve();

                            case 8:
                              return _context3.abrupt("return", _context3.t1);

                            case 9:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3);
                    }));

                    function onClick(_x6, _x7) {
                      return _onClick.apply(this, arguments);
                    }

                    return onClick;
                  }(),
                  onError: function onError(err) {
                    paypalErrorBox.classList.remove('d-none');
                  }
                }).render(checkoutButton.querySelector('.paypal-buttons'));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()).catch(function (err) {
      return console.error("failed to load the PayPal JS SDK script", err);
    });
  }

  $('.payment-options').change(checkForPaymentDetails);
  checkForPaymentDetails();
  setTimeout(function () {
    return checkForPaymentDetails();
  }, 100);
}

function checkForPaymentDetails() {
  $('.payment-options-details').addClass('d-none');
  var selectedInput = $('.payment-options input:checked');
  var optionsElement = $('div#payment-options-' + selectedInput.val());
  var selectedPaymentMethod = selectedInput === null || selectedInput === void 0 ? void 0 : selectedInput[0].dataset.type;
  checkoutForm.setAttribute('data-payment-method', selectedPaymentMethod);
  checkoutForm.setAttribute('data-paypal-sdk', usePayPalSDK);

  if (optionsElement) {
    optionsElement.removeClass('d-none');
  }
}

var getSelectedPaymentMethod = function getSelectedPaymentMethod() {
  var _$;

  return (_$ = $('.payment-options input:checked')) === null || _$ === void 0 ? void 0 : _$[0].dataset.type;
};

var couponErrorMessage = $('.coupon-form .coupon-error');
$('.coupon-form a').click(function (e) {
  e.preventDefault();

  if ($('#couponCode').val().length === 0) {
    couponErrorMessage.show();
    return;
  }

  $('.coupon-form a i').attr('class', 'fas fa-spinner fa-spin');
  couponErrorMessage.hide();
  $.ajax({
    url: '/api/validate-coupon',
    method: 'POST',
    dataType: 'json',
    data: {
      code: $('#couponCode').val(),
      locale: $(this).data('locale'),
      product: $('#product').val()
    },
    complete: function complete(response) {
      $('.coupon-form a i').attr('class', 'fa fa-arrow-circle-right');

      if (response.responseJSON === undefined || response.responseJSON.success === false) {
        couponErrorMessage.show();
      } else {
        $('.coupon-form .input-group').hide();
        $('.coupon-form .new-price').show();
        $('.coupon-form .new-price strong').text(response.responseJSON.price);
      }
    },
    error: function error() {
      return couponErrorMessage.show();
    }
  });
});

if ($('#payment-mollie-applePay').length && window.ApplePaySession === undefined) {
  $('#payment-mollie-applePay').parent().parent().hide();
}